import * as React from 'react';
import { HeaderLogoAndTel } from "../../../../../HeaderLogoAndTel";
import * as main from "../../../styles/main.module.scss";
import * as screen1 from "./screen1.module.scss";

export const Screen1WithVideo = ({ isTrial=false }) => {
  return (
    <header className={screen1.screen1}>
      <div className="container">

        <HeaderLogoAndTel/>

        <div className={screen1.screen1__wrapper}>

          <div className={screen1.screen1__info}>
            <h1 className={screen1.screen1__title}>Повысьте навыки ребёнка к&nbsp;обучению</h1>
            <p className={screen1.screen1__date}>Только на&nbsp;этой&nbsp;неделе</p>
            {
              isTrial ?
                (<p className={screen1.screen1__desc}>Получите доступ к&nbsp;курсу</p>)
                :
                (<p className={screen1.screen1__desc}>Получите <strong>полный</strong> доступ
                  к&nbsp;курсу <strong>на&nbsp;месяц</strong> и&nbsp;попробуйте сами</p>)
            }
            <div className={screen1.screen1__prices}>
              <span
                className={screen1.screen1__pricesOld}
                style={{
                  display: isTrial ? "none" : "inline-block"
                }}
              >
                99&nbsp;900&nbsp;₽
              </span>
              <span className={screen1.screen1__pricesNew}>
                {
                  isTrial ?
                    "за 1\u00A0₽"
                    :
                    "4\u00A0999\u00A0₽"
                }
              </span>
              <span
                className={screen1.screen1__pricesProfit}
                style={{
                  display: isTrial ? "none" : "inline-block"
                }}
              >
                ВЫГОДА&nbsp;95%
              </span>
            </div>
            <a href="#user-action" className={`${main.mainBtn} ${screen1.screen1__btn}`}>Попробовать</a>
          </div>

          <div className={screen1.video__content}>
            <div className={screen1.video__content_wrapper}>
              <iframe
                src="https://www.youtube.com/embed/HgSBdCueOz0?autoplay=1&loop=1&mute=1"
                title={"Учись учиться 5-7"}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                allowFullScreen
              />
            </div>
            <p className={screen1.video__text}>Онлайн-курс «Учись учиться»</p>
            <div className={screen1.screen1__infoWrapper}>
              <div className={screen1.screen1__infoCol}>
                <p className={screen1.screen1__text}>Рекомендован
                  Навигатором образования Минпросвещения РФ и «Смартекой»</p>
                <div className={screen1.screen1__imageWrapper}>
                  <div>
                    <img
                      src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/logo-minprosvet.svg"
                      alt="Минпросвещения России"
                      width="120%"
                      height="auto"
                    />
                  </div>
                  <div className={screen1.screen1__imgContainer}>
                    <img
                      src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/logo-smarteka.png"
                      alt="Смартека"
                      width="85%"
                      height="auto"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
